module.exports = __webpack_public_path__ + "static/scale-model-of-hat-&-boots-park-(oxbow-park)-in-renton-washington-f3586bf57b6f1f2adb642ad4fd5bcfc3.png";